import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d65f8c3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "page_info" }
const _hoisted_3 = { class: "page_info_title" }
const _hoisted_4 = { class: "page_info_nr" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "检验类型："),
  /*#__PURE__*/_createElementVNode("div", { class: "item_nr" }, "品质终检")
], -1))
const _hoisted_6 = { class: "items" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "物料信息：", -1))
const _hoisted_8 = { class: "item_nr" }
const _hoisted_9 = { class: "item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "工单编号：", -1))
const _hoisted_11 = { class: "item_nr" }
const _hoisted_12 = { class: "items" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "送检数量：", -1))
const _hoisted_14 = { class: "item_nr" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "检验日期：", -1))
const _hoisted_17 = { class: "item_nr" }
const _hoisted_18 = { class: "items" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item_label" }, "检验人员：", -1))
const _hoisted_20 = { class: "item_nr" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page_title" }, "检验详细信息", -1))
const _hoisted_22 = { class: "page_info1_items" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "工装：", -1))
const _hoisted_24 = { class: "nr" }
const _hoisted_25 = { class: "page_info1_items" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "合格数量：", -1))
const _hoisted_27 = { class: "nr" }
const _hoisted_28 = { class: "page_info1_items" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "不良数量：", -1))
const _hoisted_30 = { class: "nr" }
const _hoisted_31 = { class: "page_info1_items" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "不良原因：", -1))
const _hoisted_33 = { class: "nr" }

import { ref, onMounted } from 'vue'
    import { useRoute } from "vue-router"
    import { getById } from '@/apis/PlanningAPI'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const route = useRoute()

    let info = ref({})

    const getBYids = () => {
        getById(route.query.id)
            .then(res => {
                if (res.code === 200 && res.data) {
                    info.value = res.data
                }
            })
    }

    onMounted(() => {
        getBYids()
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_unref(info).code), 1),
        (_unref(info).checkType === 0)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass([ _unref(info).doneType === 0 ? 'green' : 'red' ])
            }, "检具检 - " + _toDisplayString(_unref(info).doneType === 0 ? '合格' : '不合格'), 3))
          : _createCommentVNode("", true),
        (_unref(info).checkType === 1)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass([ _unref(info).doneType === 0 ? 'green' : 'red' ])
            }, "外观检 - " + _toDisplayString(_unref(info).doneType === 0 ? '合格' : '不合格'), 3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(info).materialName) + " | " + _toDisplayString(_unref(info).materialCode), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(info).workOrderCode), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(info).num), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(info).createTime), 1)
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(info).userName) + " / " + _toDisplayString(_unref(info).departmentName), 1)
        ])
      ])
    ]),
    _hoisted_21,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).endCheckDetailList, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "page_info1",
        key: index
      }, [
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createElementVNode("div", _hoisted_24, _toDisplayString(item.appliancesCode), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, _toDisplayString(item.qualifiedNum), 1)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _hoisted_29,
          _createElementVNode("div", _hoisted_30, _toDisplayString(item.unqualifiedNum), 1)
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _createElementVNode("div", _hoisted_33, _toDisplayString(item.checkInfo ? item.checkInfo : '-'), 1)
        ])
      ]))
    }), 128))
  ]))
}
}

})